import { Color } from '@datum-group/datum-map/lib/Layer/StyleUtils/baseResources';
import { Feature } from 'ol';

export enum CartogramValueColumnName {
  '_geom_value' = 'Вычисляемое значение',
  '_ref_value' = 'Вычисляемое значение связанных слоёв',
}

export interface CreateStyleSettings {
  polygonColor?: Color;
  text?: string;
}

export interface CartogramStyleSettings {
  legendsSettings?: CartogramLegendSettings[];
  columnName?: string;
  displayedText?: string;
}

export interface CartogramLegendSettings {
  minValue: number;
  maxValue: number;
  description: string;
  color?: string;
}

export type FeaturesLegends = Record<
  string,
  { feature: Feature; legend: CartogramLegendSettings; computeColumn: string }
>;
